module.exports = __webpack_public_path__ + "static/media/icon-down-arrow.989c57db.svg";